<template>
  <main class="d-flex flex-column justify-content-sm-center align-items-center py-3">
    <ProductsListSimple :items="items" />
    <b-button
      class="mx-5 mt-4 d-xxxs-inline px-3"
      :disabled="isLoading"
      v-if="isShowMoreVisible"
      @click="loadMore"
    >{{ $t('common.showMore') }}
     <img src="@/assets/loading.svg" height="25" class="px-2" v-if="isLoading"/>
    </b-button>
  </main>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import ProductsListSimple from '@/components/ProductsListSimple.vue'

export default Vue.extend({
  name: 'ProductsView',
  components: {
    ProductsListSimple
  },
  data() {
    return {
      isLoading: false,
      bottomOfWindow: false,
      loadMoreClicked: false,
      isShowMoreVisible: true
    }
  },
  computed: {
    ...mapGetters({
      products: 'productCatalog/searchProductResults'
    }),
    items() {
      return this.products.map(value => {
        return {
          title: value.name,
          imageUrl: value.icon,
          targetUrl: '/product/' + value.id,
          genre: value.genres
            .map(g => {
              return g.name
            })
            .join(', '),
          id: value.id
        }
      })
    }
  },
  mounted() {
    if (this.products.length < 48) {
      this.loadInitialProducts()
    }
  },
  methods: {
    ...mapActions({
      loadMoreProducts: 'productCatalog/search',
      activateModal: 'modalManager/showComponent'
    }),
    loadMore() {
      this.isLoading = true
      //this.$ga.event('Game', 'GamesListShowMore')
      this.loadMoreProducts().then(response => {
        if(response.body.result.items.length === 0)
        {
          this.isShowMoreVisible = false
        }
        this.isLoading = false
      })
      this.bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight ===
        document.documentElement.offsetHeight
      window.onscroll = () => {
        this.isLoading = true
        if (this.bottomOfWindow && this.loadMoreClicked) {
          //this.$ga.event('Game', 'GamesListShowMore')
          this.loadMoreProducts().then(response => {
          if(response.body.result.items.length === 0)
          {
            this.isShowMoreVisible = false
          }
          this.isLoading = false
          })
        }
        this.isLoading = false
      }
      this.loadMoreClicked = true
    },
    loadInitialProducts() {
      if (this.products.length < 48) {
        this.loadMoreProducts().then(response => {
          this.loadInitialProducts()
        })
      }
    }
  }
})
</script>
